import { REMINDERS_AGENT, RemindersAgentView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useRemindersHold } from '../hooks/useRemindersHold';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * Appointment Reminders agent page (spec 03, amended by **amendment 25 §6**).
 *
 * Every headline is derived (see `reminders-agent/derive.ts`). Staging found the
 * page contradicting itself the same way the recall page did: *per 100 sent → 67
 * confirmed* divided by sends rather than appointments, a `1-day text` reporting
 * `16% opened` — which a text cannot report — and a channel list carrying a
 * post-op row that was a different measurement in a channel's clothes.
 *
 * The messages themselves now live in the editors under
 * `/settings/ai/reminders`.
 */
export function AppointmentRemindersPage() {
  const navigate = useNavigate();
  const { onHold, setHold } = useRemindersHold();
  const [period, setPeriod] = usePeriodRange();

  return (
    <RemindersAgentView
      data={REMINDERS_AGENT}
      onHold={onHold}
      onSetHold={setHold}
      period={period}
      onPeriodChange={setPeriod}
      onOpenSettings={() => {
        void navigate('/settings/ai/reminders');
      }}
      onOpenTriage={() => {
        void navigate('/triage?source=reminders&priority=urgent');
      }}
      onViewAllLogs={() => {
        void navigate('/communications?agent=reminders');
      }}
    />
  );
}
